import { datadogLogs } from '@datadog/browser-logs';
import { Check } from '@mui/icons-material';
import { Button, CircularProgress, Stack } from '@mui/material';
import { Cloud, FareUpdatedNotificationData, Notification } from '@silbo/core';
import { colors } from '@silbo/ui';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast as sonnerToast } from 'sonner';
import toast from '../../../toast';
import { logToastClick } from '../../../utils/log-notification-action';

export function AcknowledgeNotificationAction({ notification }: { notification: Notification }) {
  const { t } = useTranslation('patient-transport');
  const { mutate, isPending } = useMutation({
    mutationFn: async ({ notificationId }: { notificationId: string }) => {
      await Cloud.acknowledgeNotification({ notificationId });
    },
    onError: (err) => {
      toast.error(t('fareUpdatedToast.acknowledgeError'));
      datadogLogs.logger.error('acknowledge-notification-error', err);
    },
    onSettled: (_, __, { notificationId }) => {
      sonnerToast.dismiss(`fare-updated-${notificationId}`);
      logToastClick('FARE_UPDATED', (notification.data as FareUpdatedNotificationData).fare.id, notification.id);
    },
  });

  return (
    <Stack direction="row" alignItems="center">
      {isPending ? (
        <CircularProgress size={20} />
      ) : (
        <Button
          size="small"
          onClick={() => {
            mutate({ notificationId: notification.id });
          }}
          sx={{
            display: 'inline-flex',
            gap: 1,
            bgcolor: colors.blue[20],
            color: colors.blue[60],
            '&:hover': {
              bgcolor: colors.blue[30],
            },
          }}
        >
          <Check fontSize="small" />
          {t('fareUpdatedToast.seen')}
        </Button>
      )}
    </Stack>
  );
}
